export enum MockTestStatus {
  new = 'new',
  pending = 'pending',
  active = 'active',
  mock_test_submitted = 'mock_test_submitted',
  learning_path_received = 'learning_path_received',
  learning_path_activated = 'learning_path_activated',
  learning_path_deactivated = 'learning_path_deactivated',
}
